import React, { useEffect, useState } from 'react';
import { Button, Select } from '@stonelog/stonelog-design-system';
import { useDispatch, useSelector } from 'react-redux';
import {
    getDistricts, getHubs, getRegions,
    hubsSelector, resetDistrict, resetHub,
    setSelectedRegion, setSelectedDistrict, setSelectedHub
} from '../../../../features/senninha/hubsSlice';
import { clearFilter, clearHunterPin, clearStatus, setLeftOpenDrawer } from '../../../../features/senninha/pinsSlice';

import * as S from './styles';


const HubCardSelection = ({
    setStartWorkflow
}) => {

    //ids
    const [selectedRegionId, setSelectedRegionId] = useState(null)
    const [selectedDistrictId, setSelectedDistrictId] = useState(null)
    const [selectedHubId, setSelectedHubId] = useState(null)

    //desativar os select
    const [disableDistricts, setDisableDistricts] = useState(true)
    const [disableHubs, setDisableHub] = useState(true)

    const {
        regions,
        districts,
        hubs,
        regionsStatus,
        districtsStatus,
        hubsStatus,
        selectedRegionInfos,
        selectedDistrictInfos
    } = useSelector(hubsSelector);

    const dispatch = useDispatch();

    // O Select do DS entrega a option como { value, label }, mas o resto do app
    // lê o nome do polo/distrito/região em `.children` (formato do Option do antd).
    const toOptions = (list) => (list ?? []).map(({ id, name }) => ({ value: id, label: name }))
    const toInfos = (option) => ({ value: option.value, children: option.label })

    const onChangeRegion = (value, option) => {
        const component = toInfos(option)
        dispatch(
            resetDistrict(),
            resetHub()
        )
        dispatch(
            getDistricts({ //preenche o distritos da regiao selecionada
                id_regiao: value
            })
        )
        dispatch(
            setSelectedRegion({
                selectedRegionInfos: component
            })
        );

        setSelectedRegionId(value);
        setDisableDistricts(false);

        //limpar o valor dos select caso mude a regiao
        setSelectedDistrictId(null)
        setSelectedHubId(null)

        //desabilita a seleção do polo
        setDisableHub(true)
    }

    const onChangeDistrict = (value, option) => {
        const component = toInfos(option)
        dispatch(getHubs({
            id_distrito: value
        }))

        dispatch(
            setSelectedDistrict({
                selectedDistrictInfos: component
            })
        )

        setSelectedDistrictId(value);

        setSelectedHubId(null)
        setDisableHub(false)
    }

    const onChangeHub = (value, option) => {
        const component = toInfos(option)
        dispatch(
            setSelectedHub({
                selectedHubInfos: component
            })
        )
        setSelectedHubId(value);
    }

    useEffect(() => {
        dispatch(
            getRegions(),
            resetHub()
        )
        dispatch(clearStatus())
        dispatch(clearFilter('filtro'))
    }, []);

    useEffect(() => {
        dispatch(clearHunterPin())
        dispatch(setLeftOpenDrawer(false))
    }, []);

    useEffect(() => { // caso a regiao e o distrito ja esteja no slice preenchido
        if (selectedRegionInfos?.value) {
            setDisableDistricts(false)
        }
        if (selectedDistrictInfos?.value) {
            setDisableHub(false)
            dispatch(getHubs({
                id_distrito: selectedDistrictInfos.value
            }))
        }
        if (districts === null) {
            dispatch(
                getDistricts({ //preenche o distritos da regiao selecionada caso a regiao venha null(isso acontece quando o slice vem sem valor)
                    id_regiao: selectedRegionId
                })
            )
        }
    }, []);

    return (
        <S.HubContainerBackground>
            <S.HubSelectionContainer>
                <S.HubSelectionHeader>
                    <p>
                        Vamos lá?
                    </p>
                    <span>
                        Preencha as informações abaixo para começar.
                    </span>
                </S.HubSelectionHeader>
                <S.HubSelectionContent>
                    <Select
                        label='Região'
                        placeholder='Selecione uma opção'
                        size='small'
                        options={toOptions(regions)}
                        onChange={onChangeRegion}
                        loading={regionsStatus === 'pending'}
                        value={selectedRegionInfos?.value ?? null}
                        showSearch
                        optionFilterProp='label'
                    />
                    <Select
                        label='Distrito'
                        placeholder='Selecione uma opção'
                        size='small'
                        options={toOptions(districts)}
                        onChange={onChangeDistrict}
                        loading={districtsStatus === 'pending'}
                        disabled={disableDistricts || districtsStatus === 'pending'}
                        value={selectedDistrictInfos?.value ?? selectedDistrictId}
                        showSearch
                        optionFilterProp='label'
                    />
                    <Select
                        label='Polo'
                        placeholder='Selecione uma opção'
                        size='small'
                        options={toOptions(hubs)}
                        onChange={onChangeHub}
                        loading={hubsStatus === 'pending'}
                        disabled={disableHubs || hubsStatus === 'pending'}
                        value={selectedHubId}
                        showSearch
                        optionFilterProp='label'
                    />
                </S.HubSelectionContent>
                <S.HubSelectionFooter>
                    <Button
                        type='primary'
                        width='100%'
                        size='medium'
                        disabled={!selectedHubId}
                        onClick={() => setStartWorkflow(true)}
                    >
                        Começar
                    </Button>
                </S.HubSelectionFooter>
            </S.HubSelectionContainer>
        </S.HubContainerBackground>
    )
}

export default HubCardSelection;
